"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = require("react");

var _reactRedux = require("react-redux");

var _globalMessage = require("../store/globalMessage.selector");

var _globalMessage2 = require("../store/globalMessage.actions");

var CLOSING_ANIMATION_DURATION = 500;

var useGlobalMessage = function useGlobalMessage() {
  var dispatch = (0, _reactRedux.useDispatch)();
  var type = (0, _reactRedux.useSelector)(_globalMessage.getType);
  var variant = (0, _reactRedux.useSelector)(_globalMessage.getVariant);
  var isSnackbarOpen = (0, _reactRedux.useSelector)(_globalMessage.getIsSnackbarOpen);
  var isDialogOpen = (0, _reactRedux.useSelector)(_globalMessage.getIsDialogOpen);
  var icon = (0, _reactRedux.useSelector)(_globalMessage.getIcon);
  var message = (0, _reactRedux.useSelector)(_globalMessage.getText);
  var errorDetails = (0, _reactRedux.useSelector)(_globalMessage.getErrorDetails); // in order to preserve components' closing animation

  var hideMessageHandler = (0, _react.useCallback)(function () {
    dispatch((0, _globalMessage2.hideGlobalMessageComponent)());
    setTimeout(function () {
      return dispatch((0, _globalMessage2.hideGlobalMessage)());
    }, CLOSING_ANIMATION_DURATION);
  }, [dispatch]);
  var showMessageHandler = (0, _react.useCallback)(function (params) {
    if (variant) {
      dispatch((0, _globalMessage2.hideGlobalMessageComponent)());
    }

    dispatch((0, _globalMessage2.showGlobalMessage)(params));
  }, [dispatch, variant]);
  return {
    type: type,
    variant: variant,
    isDialogOpen: isDialogOpen,
    isSnackbarOpen: isSnackbarOpen,
    message: message,
    errorDetails: errorDetails,
    icon: icon,
    hideGlobalMessage: hideMessageHandler,
    showGlobalMessage: showMessageHandler
  };
};

var _default = useGlobalMessage;
exports["default"] = _default;